import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=5b5e96ab&scoped=true&"
import script from "./PaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethod.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=5b5e96ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e96ab",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRadio: require('/usr/www/nuxt/components/Base/BaseRadio.vue').default,IconCard: require('/usr/www/nuxt/components/Icon/IconCard.vue').default})
